import { FC } from 'react';
import { Styled } from '.';
import { FlashSaleTimerHeader } from 'components/FlashSaleTimerHeader';
import { usePromotionList } from 'reactQuery/queries';
import { useRouter } from 'next/router';
import { FaShippingFast } from 'react-icons/fa';

const MessageBar: FC = () => {
  const { data } = usePromotionList();
  const router = useRouter();

  const freeShipping = data?.productsList
    .flatMap(product => product.discounts)
    .find(
      discount =>
        discount.discountType === 'coupon' && discount.type === 'Shipping'
    );

  const isFlashSaleAvailable =
    data?.flashSale &&
    data?.flashSale.message?.length > 0 &&
    data.flashSale.expiresAtUTC?.length > 0;

  return isFlashSaleAvailable || freeShipping ? (
    <Styled.MessageBarContainer
      onClick={() => {
        if (isFlashSaleAvailable) {
          router.push('/flashsale');
        }
      }}
    >
      <Styled.MessageBar>
        {freeShipping ? (
          <Styled.FreeShippingContainer fullWidth={!isFlashSaleAvailable}>
            <div>
              <FaShippingFast size={24} />
              <div>{freeShipping.description}</div>
            </div>
            {isFlashSaleAvailable ? <Styled.Divider /> : null}
          </Styled.FreeShippingContainer>
        ) : null}
        {isFlashSaleAvailable ? (
          <>
            <div>
              <FlashSaleTimerHeader expiresAt={data?.flashSale.expiresAtUTC} />
            </div>
            <Styled.FlashSaleMessage>
              {data?.flashSale.message}
            </Styled.FlashSaleMessage>
            <Styled.FlashSaleButtonContainer>
              <Styled.FlashSaleButton
                onClick={() => router.push('/flashsale')}
                variant={'white'}
              >
                Shop Now
              </Styled.FlashSaleButton>
            </Styled.FlashSaleButtonContainer>
          </>
        ) : null}
      </Styled.MessageBar>
    </Styled.MessageBarContainer>
  ) : null;
};

export default MessageBar;
